import React from 'react';
import {
  Page,
  Text,
  Font,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import moment from 'moment';
import imageToBase64 from 'image-to-base64/browser';
import p2vestLogo from '../../assets/img/logo.png';

Font.register({
  family: 'Roboto',
  src:
    'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf',
});

Font.register({
  family: 'Roboto-Bold',
  src:
    'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    fontFamily: 'Roboto',
    padding: 10,
  },
  logo: {
    width: '25%',
    display: 'block',
    marginTop: 10,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  lenderNameHeader: {
    display: 'block',
    marginTop: 30,
    marginBottom: 5,
    textAlign: 'right',
  },
  lenderName: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  lender: {
    fontWeight: 'bold',
    whiteSpace: 'pre',
    fontSize: 10,
  },
  hr: {
    display: 'block',
    height: '2px',
    border: 0,
    borderTop: '2px solid black',
    margin: '1em 0',
    padding: 0,
  },
  scheduleHeader: {
    width: '70%',
    display: 'block',
    marginTop: 30,
    marginBottom: 10,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  scheduleText: {
    fontWeight: 'bold',
    fontSize: 16,
    letterSpacing: 7,
  },
  summaryHeader: {
    width: '20.9%',
    display: 'block',
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 'auto',
    marginRight: 'auto',

  },
  summaryText: {
    fontWeight: 'bold',
    fontSize: 16,
    letterSpacing: 7,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  scheduleTableColHeader: {
    width: '10.53%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  scheduleSNTableColHeader: {
    width: '5%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  scheduleTableCol: {
    width: '10.53%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  scheduleSNTableCol: {
    width: '5%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  summaryTableColHeader: {
    width: '50%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  summaryTableCol: {
    width: '50%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 'auto',
    margin: 3,
    fontSize: 8,
    fontWeight: 'bold',
    fontFamily: 'Roboto-Bold',
  },
  tableCell: {
    // margin: "auto",
    margin: 3,
    textAlign: 'right',
    fontSize: 6,
  },
  tableCellText: {
    margin: 'auto',
    margin: 3,
    fontSize: 6,
  },
  tableCellSN: {
    margin: 'auto',
    margin: 3,
    fontSize: 6,
    fontFamily: 'Roboto-Bold',
  },
  tableCellPaid: {
    fontFamily: 'Roboto-Bold',
    // margin: "auto",
    margin: 3,
    textAlign: 'right',
    fontSize: 6,
  },
  tableCellBold: {
    fontFamily: 'Roboto-Bold',
    // margin: "auto",
    margin: 3,
    textAlign: 'right',
    fontSize: 6,
  },
});

export function PdfDocument(props) {
  console.log(props);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image
          style={styles.logo}
          source={`${p2vestLogo}`} />
        <View style={styles.lenderNameHeader}>
          <Text style={styles.lender}>LENDER</Text>
          <Text style={styles.lenderName}>{`${props?.user?.organization?.name}`}</Text>
        </View>
        <View style={styles.hr} />
        <View style={styles.summaryHeader}>
          <Text style={styles.summaryText}>SUMMARY</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.summaryTableColHeader}>
              <Text style={styles.tableCellHeader}>NAME</Text>
            </View>
            <View style={styles.summaryTableColHeader}>
              <Text style={styles.tableCellHeader}>PRINCIPAL AMOUNT</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.summaryTableCol}>
              <Text style={styles.tableCellText}>{`${`${props?.loan?.user?.first_name} ${props?.loan?.user?.last_name}` || '---'}`}</Text>
            </View>
            <View style={styles.summaryTableCol}>
              <Text style={styles.tableCellText}>{`₦${Number(props?.loan?.loan_amount).toLocaleString()}`}</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.summaryTableColHeader}>
              <Text style={styles.tableCellHeader}>INTEREST RATE</Text>
            </View>
            <View style={styles.summaryTableColHeader}>
              <Text style={styles.tableCellHeader}>TENOR</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.summaryTableCol}>
              <Text style={styles.tableCellText}>{`${Number(props?.loan?.interest_rate).toLocaleString()}%`}</Text>
            </View>
            <View style={styles.summaryTableCol}>
              <Text style={styles.tableCellText}>{`${Number(props?.loan?.tenor).toLocaleString()}${' '}${props?.loan?.tenor_period}`}</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.summaryTableColHeader}>
              <Text style={styles.tableCellHeader}>DATE DISBURSED</Text>
            </View>
            <View style={styles.summaryTableColHeader}>
              <Text style={styles.tableCellHeader}>MATURITY DATE</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.summaryTableCol}>
              <Text style={styles.tableCellText}>{`${props?.loan?.disbursed_on ? moment(props?.loan?.disbursed_on).format('MMM DD, YYYY') : '---'}`}</Text>
            </View>
            <View style={styles.summaryTableCol}>
              <Text style={styles.tableCellText}>{`${props?.schedules[props?.schedules?.length - 2].Date ? props?.schedules[props?.schedules?.length - 2].Date : '---'}`}</Text>
            </View>
          </View>
        </View>
        <View style={styles.scheduleHeader}>
          <Text style={styles.scheduleText}>LOAN REPAYMENT SCHEDULE</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.scheduleSNTableColHeader}>
              <Text style={styles.tableCellHeader}>S/N</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>DATE</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>DESCRIPTION</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>PRINCIPAL</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>INTEREST</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>AMOUNT DUE</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>AMOUNT PAID</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>PENALTY</Text>
            </View>
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>BALANCE</Text>
            </View>
            
            <View style={styles.scheduleTableColHeader}>
              <Text style={styles.tableCellHeader}>STATUS</Text>
            </View>
          </View>

          {props.schedules
            ? props.schedules.map((schedule, index) => (
              <View style={styles.tableRow}>
                {index + 1 === props.schedules.length && (
                  <View style={styles.scheduleSNTableCol}>
                    <Text style={styles.tableCellSN}>Total</Text>
                  </View>
                )}
                {index + 1 !== props.schedules.length && (
                  <View style={styles.scheduleSNTableCol}>
                    <Text style={styles.tableCellSN}>{index + 1 ?? '---'}</Text>
                  </View>
                )}
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCellText}>{schedule.Date}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCellText}>{schedule.Description}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCell}>{schedule.Principal}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCell}>{schedule.Interest}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCell}>{schedule['Amount Due']}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={styles.tableCellPaid}>{schedule.Paid}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCell}>{schedule.Penalty}</Text>
                </View>
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCell}>{schedule['Pending Due']}</Text>
                </View>
                  
                <View style={styles.scheduleTableCol}>
                  <Text style={index + 1 === props.schedules.length ? styles.tableCellBold : styles.tableCellText}>{schedule.Status}</Text>
                </View>
              </View>
            ))
            : ''}
        </View>
      </Page>
    </Document>
  );
}
